import { useCallback } from 'react';
import { usePostFavoriteMarket } from '../queries/usePostFavoriteMarket';
import { useDeleteFavoriteMarket } from '../queries/useDeleteFavoriteMarket';
import {
  useLogClickFavoriteRecommendedMarket,
  type RecommendedMarketAnalyticsTarget,
} from './useLogClickFavoriteMarket';

export const useOnPressFavoriteRecommendedMarket = (params: {
  market: RecommendedMarketAnalyticsTarget;
  favorite: { market_sno: number; created_at: string } | null;
}) => {
  const logClickFavoriteMarket = useLogClickFavoriteRecommendedMarket(
    params.market,
  );

  const {
    mutateAsync: postFavoriteMarket,
    isPending: loadingPostFavoriteMarket,
  } = usePostFavoriteMarket(params.market.sno);

  const {
    mutateAsync: deleteFavoriteMarket,
    isPending: loadingDeleteFavoriteMarket,
  } = useDeleteFavoriteMarket(params.market.sno);

  return {
    action: useCallback(async () => {
      if (params.favorite) {
        logClickFavoriteMarket(true);
        return deleteFavoriteMarket();
      } else {
        logClickFavoriteMarket(false);
        return postFavoriteMarket();
      }
    }, [
      params.favorite,
      logClickFavoriteMarket,
      deleteFavoriteMarket,
      postFavoriteMarket,
    ]),
    loading: loadingPostFavoriteMarket || loadingDeleteFavoriteMarket,
  };
};
